import { render, staticRenderFns } from "./Loading_comp.vue?vue&type=template&id=0d21addf&scoped=true&"
import script from "./Loading_comp.vue?vue&type=script&lang=js&"
export * from "./Loading_comp.vue?vue&type=script&lang=js&"
import style0 from "./Loading_comp.vue?vue&type=style&index=0&id=0d21addf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d21addf",
  null
  
)

export default component.exports